import React, { useEffect, useState } from "react";
import "./boxedDetails.css";
import Global from "../../global";
import Share from "../share/share";
import { favourited, favourites } from "../javascript/function";
import { UserStore } from "../store/store";
import ShowMoreText from "react-show-more-text";
import { useTranslation } from "react-i18next";

const BoxedDetails = (props) => {
  const currentUser = UserStore.useState((s) => s.user);
  const [box, setBox] = useState(props.data);
  const { t } = useTranslation(["translation"]);

  useEffect(() => {
    setBox(props.data);
  }, [props.data]);

  return (
    <div className="boxedDetail">
      <div className="play-details-content">
        <div className="title-block d-flex align-items-center justify-content-between">
          <h2 className="play-title">{box.title}</h2>
        </div>
        <div className="social">
          {Global.FAVOURITES ? (
            <a
              href="#!"
              className="icon-bttn"
              onClick={(event) => {
                favourites(event, box, "video");
              }}
            >
              <i
                className={
                  favourited(box.mediaid, currentUser.FAVOURITES)
                    ? "ri-check-fill text-white"
                    : "ri-add-line text-white"
                }
              />
            </a>
          ) : (
            ""
          )}
          {Global.SOS ? (
            <a href="#!" className="icon-bttn share">
              <i className="ri-share-line text-white" />{" "}
              <Share type={"video"} details={box} {...props}></Share>
            </a>
          ) : (
            ""
          )}
          {Global.OFFLINE ? (
            <a href="#!" className="icon-bttn">
              <i className="ri-download-line text-white" />
            </a>
          ) : (
            ""
          )}
        </div>
        {/* Title Block */}
        <ShowMoreText
          /* Default options */
          lines={3}
          more={t("label_Show_More")}
          less={t("label_Show_Less")}
          anchorClass="my-anchor-css-class"
          expanded={false}
          truncatedEndingComponent={"... "}
          className="details-desc"
        >
          <p>{box.description}</p>
        </ShowMoreText>
      </div>
    </div>
  );
};

export default BoxedDetails;
